export const ChangeDomainTestIds = {
  DOMAIN_INPUT: 'change-domain.domain-input',
  SAVE_BUTTON: 'change-domain.save-button',
  RESET_BUTTON: 'change-domain.reset-button',
};
